<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div>
            <div style="overflow:auto">
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('1301')}}</div>

                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('411')}} {{$t('3395')}}:</div>
                    </div>
                    <div v-if="ltr_list.length==0 || ltr_list.length>4">
                        <select v-model="ltr_select" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: ltr_select==null, my_input_background_color_at_validInput:ltr_select!=null}">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="ltr in ltr_list" v-bind:value="ltr">
                                {{ltr.text.useTextKey?$t(ltr.text.textKey):ltr.text.textUI}}
                            </option>
                        </select>
                    </div>
                    <div v-if="ltr_list.length>0 && ltr_list.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: ltr_select==null, my_input_background_color_at_validInput:ltr_select!=null}">
                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                <li v-for="ltr in ltr_list">
                                    <input type="checkbox" @input="change_Selected_atElementOf_ltr(ltr)" v-bind:checked="ltr.selected" v-bind:disabled="ltr.selected" />
                                    <span style="margin-left:10px">{{ltr.text.useTextKey?$t(ltr.text.textKey):ltr.text.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="showTractionSheaveDetails==true">
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3460')}}:</div>
                        </div>
                        <div v-if="lthd_list.length==0 || lthd_list.length>4">
                            <select v-model="lthd_select" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: lthd_list.length > 0 && lthd_select==null, my_input_background_color_at_validInput: lthd_list == 0 || lthd_select!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="lthd in lthd_list" v-bind:value="lthd">
                                    {{lthd.text.useTextKey?$t(lthd.text.textKey):lthd.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="lthd_list.length>0 && lthd_list.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: lthd_list.length > 0 && lthd_select==null, my_input_background_color_at_validInput: lthd_list == 0 || lthd_select!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="lthd in lthd_list">
                                        <input type="checkbox" @input="change_Selected_atElementOf_lthd(lthd)" v-bind:checked="lthd.selected" v-bind:disabled="lthd.selected" />
                                        <span style="margin-left:10px">{{lthd.text.useTextKey?$t(lthd.text.textKey):lthd.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3038')}} | {{$t('1182')}}:</div>
                        </div>
                        <div v-if="td_tb_list.length==0 || td_tb_list.length>4">
                            <div class="my_input-group">
                                <select v-model="td_tb_select" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: td_tb_select==null, my_input_background_color_at_validInput:td_tb_select!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="td_tb in td_tb_list" v-bind:value="td_tb">{{td_tb.text}}</option>
                                </select>
                                <div class="my_input-group_unit ZAfont_family" style="width:auto;max-width:60px">mm</div>
                            </div>
                        </div>
                        <div v-if="td_tb_list.length>0 && td_tb_list.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: td_tb_select==null, my_input_background_color_at_validInput:td_tb_select!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="td_tb in td_tb_list">
                                        <input type="checkbox" @input="change_Selected_atElementOf_td_tb(td_tb)" v-bind:checked="td_tb.selected" v-bind:disabled="td_tb.selected" />
                                        <span style="margin-left:10px">{{td_tb.text}} mm</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="showInfoTractionSheave==true" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div> </div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3063')}}:</div>
                    </div>
                    <div v-if="showInfoTractionSheave==false">
                        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('1067')}}</div>
                            </div>
                            <div v-if="tcsd_length==0 || tcsd_length>4">
                                <div class="my_input-group">
                                    <select v-model="tcsd_select" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: tcsd_select==null, my_input_background_color_at_validInput:tcsd_select!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="tcsd in tcsd_list" v-bind:value="tcsd" v-if="tcsd.disabled==false">
                                            {{tcsd.max!=null?ValueDecimalSeparator(tcsd.value) + ' - ' + ValueDecimalSeparator(tcsd.max):ValueDecimalSeparator(tcsd.value)}}
                                        </option>
                                    </select>
                                    <div class="my_input-group_unit ZAfont_family" style="width:auto;max-width:60px">mm</div>
                                </div>
                            </div>
                            <div v-if="tcsd_length>0 && tcsd_length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: tcsd_select==null, my_input_background_color_at_validInput:tcsd_select!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="tcsd in tcsd_list" v-if="tcsd.disabled==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_tcsd(tcsd)" v-bind:checked="tcsd.selected" v-bind:disabled="tcsd.selected" />
                                            <span style="margin-left:10px">{{tcsd.max!=null?ValueDecimalSeparator(tcsd.value) + ' - ' + ValueDecimalSeparator(tcsd.max):ValueDecimalSeparator(tcsd.value)}} mm</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('294')}}:</div>
                            </div>
                            <div v-if="tdra_length==0 || tdra_length>4">
                                <div class="my_input-group">
                                    <select v-model="tdra_select" class="my_select" style="width:100%" v-bind:disabled="tcsd_select==null || tcsd_select.value==null" v-bind:class="{my_input_border_at_invalidInput: tdra_select==null, my_input_background_color_at_validInput:tdra_select!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="tdra in tdra_list" v-bind:value="tdra" v-if="tdra.disabled==false">{{ValueDecimalSeparator(tdra.value)}}</option>
                                    </select>
                                    <div class="my_input-group_unit ZAfont_family" style="width:auto;max-width:60px">mm</div>
                                </div>
                            </div>
                            <div v-if="tdra_length>0 && tdra_length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: tdra_select==null, my_input_background_color_at_validInput:tdra_select!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="tdra in tdra_list" v-if="tdra.disabled==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_tdra(tdra)" v-bind:checked="tdra.selected" v-bind:disabled="tdra.selected" />
                                            <span style="margin-left:10px">{{ValueDecimalSeparator(tdra.value)}} mm</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('165')}}:</div>
                            </div>
                            <div v-if="tdrz_length==0 || tdrz_length>4">
                                <select v-model="tdrz_select" class="my_select" style="width:100%" v-bind:disabled="tdra_select==null || tdra_select.value==null" v-bind:class="{my_input_border_at_invalidInput: tdrz_select==null, my_input_background_color_at_validInput:tdrz_select!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="tdrz in tdrz_list" v-bind:value="tdrz" v-if="tdrz.disabled==false">{{tdrz.value}}</option>
                                </select>
                            </div>
                            <div v-if="tdrz_length>0 && tdrz_length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: tdrz_select==null, my_input_background_color_at_validInput:tdrz_select!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="tdrz in tdrz_list" v-if="tdrz.disabled==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_tdrz(tdrz)" v-bind:checked="tdrz.selected" v-bind:disabled="tdrz.selected" />
                                            <span style="margin-left:10px">{{tdrz.value}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('1123')}}:</div>
                            </div>
                            <div v-if="tarill_length==0 || tarill_length>4">
                                <select v-model="tarill_select" class="my_select" style="width:100%" v-bind:disabled="tdrz_select==null || tdrz_select==''" v-bind:class="{my_input_border_at_invalidInput: tarill_select==null, my_input_background_color_at_validInput:tarill_select!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="tarill in tarill_list" v-if="tarill.disabled==false" v-bind:value="tarill">{{tarill.text.textUI}}</option>
                                </select>
                            </div>
                            <div v-if="tarill_length>0 && tarill_length<=4">
                                <div v-bind:class="{my_input_border_at_invalidInput: tarill_select==null, my_input_background_color_at_validInput:tarill_select!=null}">
                                    <ul class="my_inputCheckbox2 ZAfont_family ZAfont_size">
                                        <li v-for="tarill in tarill_list" v-if="tarill.disabled==false">
                                            <div>
                                                <input type="checkbox" @input="change_Selected_atElementOf_tarill(tarill)" v-bind:checked="tarill.selected" v-bind:disabled="tarill.selected" />
                                                <span style="margin-left:10px">{{tarill.text.useTextKey?$t(tarill.text.textKey):tarill.text.textUI}}</span>
                                                <span v-if="tarill.text.useTextKey == true" style="margin-left:10px">{{$t(tarill.text.textKey)}}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="taub_show==false" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('1134')}}:</div>
                            </div>
                            <div>
                                <div class="my_input-group">
                                    <select v-model="tauwi_select" class="my_select" style="width:100%" v-bind:disabled="tauwi_disabled==true || tarill_select==null || tarill_select==''" v-bind:class="{my_input_border_at_invalidInput: tauwi_length > 0 && tauwi_select==null, my_input_background_color_at_validInput:tauwi_length==0 || tauwi_select!=null}">
                                        <option v-for="tauwi in tauwi_list" v-bind:value="tauwi" v-if="tauwi.disabled==false">{{ValueDecimalSeparator(tauwi.value)}}</option>
                                    </select>
                                    <div class="my_input-group_unit ZAfont_family" style="width:auto;max-width:60px">&#176;</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="taub_show==true" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('1134')}}:</div>
                            </div>
                            <div>
                                <select v-model="tauwi_select" class="my_select" style="width:100%" v-bind:disabled="tauwi_disabled==true || tarill_select==null || tarill_select==''" v-bind:class="{my_input_border_at_invalidInput: tauwi_length > 0 && tauwi_select==null, my_input_background_color_at_validInput:tauwi_length==0 || tauwi_select!=null}">
                                    <option v-for="tauwi in tauwi_list" v-bind:value="tauwi" v-if="tauwi.disabled==false">{{ValueDecimalSeparator(tauwi.ub)}} mm ({{ValueDecimalSeparator(tauwi.value)}}&#176;)</option>
                                </select>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('1135')}}:</div>
                            </div>
                            <div>
                                <div class="my_input-group">
                                    <select v-model="takwi_select" class="my_select" style="width:100%" v-bind:disabled="takwi_disabled==true ||tarill_select==null || tarill_select==''" v-bind:class="{my_input_border_at_invalidInput: takwi_length > 0 && takwi_select==null, my_input_background_color_at_validInput:takwi_length==0 || takwi_select!=null}">
                                        <option v-for="takwi in takwi_list" v-bind:value="takwi" v-if="takwi.disabled==false">{{takwi.value}}</option>
                                    </select>
                                    <div class="my_input-group_unit ZAfont_family" style="width:auto;max-width:60px">&#176;</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="mn_ts_select!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>{{$t('3427')}}</div>
                            <div>
                                <div>
                                    <span>{{mn_ts_select}}</span>
                                    <span v-if="tractionSheaveSelection!=null&&tractionSheaveSelection.length>1" style="margin-left:10px; margin-bottom:0px; text-align:left">
                                        <a @click.prevent="showModalInputSelection" class="ZAfont_family ZAfont_size" href="#">{{$t('3182')}}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="kiddrw_select!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>{{$t('3544')}}</div>
                            <div>{{kiddrw_select}}</div>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
    </div>
</template>


<script>
    import router from '../../../router';
    import { configurations } from '../../../store/configurations.module';
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import LoaderIcon from '../../loader/LoaderIcon';
    import axios from 'axios';
    import Images from '../../configuration/Images';
    export default {
        name: 'TractionSheaveModal',

        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
        },


        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            ltr_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection;
                },
            },
            ltr_select: {
                get() {
                    return this.ltr_list != null && Array.isArray(this.ltr_list) ? this.ltr_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_ltr(value);
                }
            },
            showInfoTractionSheave: {
                get() {
                    return this.$store.state.tractionSheaveManual.showInfoTractionSheave != null && this.$store.state.tractionSheaveManual.showInfoTractionSheave == true
                        ? this.showTractionSheaveDetails
                        : false;
                },
            },
            showTractionSheaveDetails: {
                get() {
                    return this.$store.state.tractionSheaveManual.showTractionSheaveDetails;
                },
            },
            lthd_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.machiningForHandWheelSelection;
                },
            },
            lthd_select: {
                get() {
                    return this.lthd_list != null && Array.isArray(this.lthd_list) ? this.lthd_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_lthd(value);
                }
            },

            td_tb_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.tractionSheave_DiameterAndWidthSelection;
                },
            },
            td_tb_select: {
                get() {
                    return this.td_tb_list != null && Array.isArray(this.td_tb_list) ? this.td_tb_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_td_tb(value);
                }
            },
            tarill_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.sheaveProfileSelection;
                },
            },
            tarill_select: {
                get() {
                    return this.tarill_list != null && Array.isArray(this.tarill_list) ? this.tarill_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_tarill(value);
                },
            },
            tarill_length: {
                get() {
                    return Array.isArray(this.tarill_list) ? this.tarill_list.filter(x => x.disabled == false).length : 0;
                }
            },
            tcsd_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.ropeDiameterSelection;
                },
            },
            tcsd_length: {
                get() {
                    return Array.isArray(this.tcsd_list) ? this.tcsd_list.filter(x => x.disabled == false).length : 0;
                }
            },
            tcsd_select: {
                get() {
                    return this.tcsd_list != null && Array.isArray(this.tcsd_list) ? this.tcsd_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_tcsd(value);
                }
            },
            tauwi_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.undercutAngleSelection;
                },
            },
            tauwi_disabled: {
                get() {
                    return this.tauwi_list == null || this.tauwi_list.length < 1 ? true : false;
                },
            },
            tauwi_length: {
                get() {
                    return Array.isArray(this.tauwi_list) ? this.tauwi_list.filter(x => x.disabled == false).length : 0;
                }
            },
            tauwi_select: {
                get() {
                    return this.tauwi_list != null && Array.isArray(this.tauwi_list) ? this.tauwi_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_tauwi(value);
                },
            },
            taub_show: {
                get() {
                    if (!Array.isArray(this.tarill_list)) {
                        return false;
                    }

                    const tarill_select = this.tarill_list.find(i => i.selected == true);
                    const selectedText = tarill_select != null && tarill_select.text != null ? tarill_select.text.text : null;

                    return selectedText != null && selectedText.indexOf("SC-") > -1 && selectedText.indexOf("BZU") > -1;
                }
            },
            takwi_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.vgrooveAngleSelection;
                },
            },
            takwi_disabled: {
                get() {
                    return this.takwi_list == null || this.takwi_list.length < 1 ? true : false;
                },
            },
            takwi_length: {
                get() {
                    return Array.isArray(this.takwi_list) ? this.takwi_list.filter(x => x.disabled == false).length : 0;
                }
            },
            takwi_select: {
                get() {
                    return this.takwi_list != null && Array.isArray(this.takwi_list) ? this.takwi_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_takwi(value);
                },
            },
            tdra_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.grooveDistanceSelection;
                },
            },
            tdra_length: {
                get() {
                    return Array.isArray(this.tdra_list) ? this.tdra_list.filter(x => x.disabled == false).length : 0;
                }
            },
            tdra_select: {
                get() {
                    return this.tdra_list != null && Array.isArray(this.tdra_list) ? this.tdra_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_tdra(value);
                }
            },
            tdrz_list: {
                get() {
                    return this.$store.state.tractionSheaveManual.numberOfGroovesSelection;
                },
            },
            tdrz_length: {
                get() {
                    return Array.isArray(this.tdrz_list) ? this.tdrz_list.filter(x => x.disabled == false).length : 0;
                }
            },
            tdrz_select: {
                get() {
                    return this.tdrz_list != null && Array.isArray(this.tdrz_list) ? this.tdrz_list.find(i => i.selected == true) : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_tdrz(value);
                }
            },
            tractionSheaveSelection: {
                get() {
                    return this.$store.state.inputsManual.tractionSheavedetailsSelection;
                }
            },
            mn_ts_select: {
                get() {
                    return this.tractionSheaveSelection != null && Array.isArray(this.tractionSheaveSelection) ? this.tractionSheaveSelection.find(i => i.selected)?.id || null : null;
                }
            },
            kiddrw_select: {
                get() {
                    return this.tractionSheaveSelection != null && Array.isArray(this.tractionSheaveSelection) ? this.tractionSheaveSelection.find(i => i.selected)?.kiddrw || null : null;
                }
            },
            showInputSelectionModal: {
                get() {
                    return this.$store.state.inputsManual.showInputSelectionModal_TractionSheave;
                }
            },
        },

        created() {
            if (this.$store.state.ropeGuardManual.deliverRopeSelection == null || this.$store.state.ropeGuardManual.deliverRopeSelection.length == 0) {
                this.$store.dispatch('tractionSheaveManual/set_tractionSheaveManual_storeAction');
            }
        },

        methods: {
            ValueDecimalSeparator(value) {
                if (value != null) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                }
                return value;
            },

            // traction sheave
            change_Selected_atElementOf_ltr(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_LTR_Selected_storeAction', value);
            },
            change_Selected_atElementOf_lthd(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_LTHD_storeAction', value);
            },
            change_Selected_atElementOf_td_tb(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_TD_TB_Selected_storeAction', value);
            },
            change_Selected_atElementOf_tcsd(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_TCSD_storeAction', value);
            },
            change_Selected_atElementOf_tdra(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_TDRA_storeAction', value);
            },
            change_Selected_atElementOf_tdrz(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_TDRZ_storeAction', value);
            },
            change_Selected_atElementOf_tarill(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_TARILL_storeAction', value);
            },
            change_Selected_atElementOf_takwi(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_TAKWI_storeAction', value);
            },
            change_Selected_atElementOf_tauwi(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_TAUWI_storeAction', value);
            },
            showModalInputSelection() {
                this.$store.dispatch('inputsManual/change_showInputSelectionModal_storeAction', { value: true, component: 'tractionSheave' });
            },
        },
    }
</script>


<style>
    .my_inputCheckboxSelected {
        border: none !important;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

    .my_inputCheckbox2 {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox2 li {
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

    .my_inputCheckbox {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox li {
            display: inline-block;
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

            .my_inputCheckbox li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_inputCheckbox li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }
</style>
